import { useTranslation } from 'react-i18next';
import { MerchantDetails } from '@repo/api/endpoints/merchant';

import { EditableRow } from '../common/components/editable-row';
import { COUNTRIES } from '../common/helpers/countries';

export function LiberisCompanyData({ merchantDetails }: { merchantDetails?: MerchantDetails }) {
  const { t } = useTranslation();

  const bankAccountValues = merchantDetails
    ? merchantDetails.bankAccount.filter((account) => account.iban)
    : [];

  const bankAccountsOptions = bankAccountValues.map((elem, id) => {
    return { id, name: elem.iban, value: elem.id.toString() };
  });

  const companyFields = [
    {
      label: t('welcomePage.loanApplicationPossible.liberis.companyData.form.street'),
      fieldName: 'merchantData.address.street',
      fieldType: 'text',
    },
    {
      label: t('welcomePage.loanApplicationPossible.liberis.companyData.form.postCode'),
      fieldName: 'merchantData.address.postCode',
      fieldType: 'postCode',
    },
    {
      label: t('welcomePage.loanApplicationPossible.liberis.companyData.form.city'),
      fieldName: 'merchantData.address.city',
      fieldType: 'text',
    },
    {
      label: t('welcomePage.loanApplicationPossible.liberis.companyData.form.country'),
      fieldName: 'merchantData.address.country',
      fieldType: 'select',
      options: [...COUNTRIES],
    },
    {
      label: t('welcomePage.loanApplicationPossible.liberis.companyData.form.iban'),
      fieldName: 'ibanId',
      fieldType: 'select',
      options: bankAccountsOptions,
    },
  ];

  if (merchantDetails && !merchantDetails.companyRegisterDate) {
    companyFields.push({
      label: t('welcomePage.loanApplicationPossible.liberis.companyData.form.companyRegisterDate'),
      fieldName: 'companyRegisterDate',
      fieldType: 'date',
    });
  }

  return companyFields.map((field, index) => (
    <EditableRow {...field} index={index} key={field.fieldName} />
  ));
}
